/*
Lalitha 12/19/2022  3075154998 Added Search Data Manager Form
Sohel  12/19/2022 3075154998 removed fields.
Lalitha 12/20/2022  3075154998 Added Created Date in Data Manager Form
Lalitha 12/23/2022  3075154998 Added Status Field in Data Manager Form
Sohel 12/23/2022 3075154998 Integrated Data Manager Search API
Suresh Peddavoora 01/03/2023 3075154998 Fixed Responsive issues for Textfields and Buttons
dilip 01/09/2023 3075154998 Added Search data session storage functionality
Sohel 01/09/2023 3075154998 Added conditionally Search data session storage functionality
kavyareddy 01/10/2023 3075154998 Fixed code issue
dilip 01/10/2023 3075154998 Removed Type field.
Prakash 01/16/2023 3075154998 Fixed Responsiveness.
Suresh Peddavoora 01/17/2023 3075154998 Fixed Responsive issues for Textfields and Buttons
Suresh Peddavoora 01/19/2023 3075154998 Added Classnames for Textfields
Sohel 01/20/2023 3075154998 changed Dropdown Values
Dilip 02/09/2023 3075154998 added created for, created by dropdown
sai krishna 02/13/2023 3075154998 added search client code field
suresh peddavoora 02/22/2023 3075154998 New UI changes implemented
suresh peddavoora 02/27/2023 3075154998 New UI changes
Raghu 02/27/2023 3075154998 fixed ui alignments
Rohini 02/28/2023 3075154998 changed the columns grid for screen enhancements.
suresh peddavoora 03/01/2023 3075154998 New UI changes
Rohini 03/09/2023 3075154998 fixed the alignment issue in text fields.
Raghu 03/14/2023 3075154998 fixed the alignment issues in responsive
Prakash 03/16/2023 3075154998 fixed ui bugs in responsive.
T Santosh Kumar 17/03/2023 3075154998 New UI Alignment Changes
Prakash 03/17/2023 3075154998 fixed alignments in responsive.
Prakash 03/20/2023 3075154998 fixed alignments issues.
Akhila 04/19/2023 3075154998 client code dropDown Data fix
Sohel 05/22/2023 3075154998 Added Imports and Exports in Schedular
Prakash 22/05/2023 3075154998 fixed popup issue.
Sohel 05/26/2023 3225736869 Added Created Date Validation
Akhila 06/08/2023 3225736869 rearrange the column and form fields
Akhila 06/12/2023 3225736869 added role access
Prakash 22/06/2023 3225736869 fixed alignments issues
Gireesh 11/12/2023 3225736869 removed case sensitive for code 
*/
import React, {useContext, useEffect, useState} from 'react';
import {Form, Formik} from 'formik';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import {useSelector, useDispatch} from 'react-redux';
import SearchDMTable from './SearchDMTable';
import {
  getAllReportCreatedForData,
  fetchCreatedForDropDownData,
  fetchCreatedByDropDownData,
} from '../../../../../redux/reducers/ReportMaster';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {getClientCodeDropDownData} from '../../../../../redux/reducers/TriggerGroup';
import * as Yup from 'yup';
import {createForOptions, createdByOptions} from '../../../../../util/CreatedByForOptions';
const importManagerType = [
  {value: 'New Account Import'},
  // { value: "New Payment Import" },
  {value: 'Data Update'},
  {value: 'Customer Query'},
];

const StatusOptions = [
  {key: 'Y', value: 'Draft'},
  {key: 'N', value: 'Completed'},
];

function SearchDataManager({
  setValue,
  exportManager,
  isSchedular = false,
  setDMCode = () => {},
  setIsCodeSearch = () => {},
  setEditExisting,
  DataManagerAccess,
  setDmTableData= () => {},
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {createdForData, createdByData} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const dispatch = useDispatch();
  const initialValues = {
    dataManagerCode: '',
    dataManagerDescripton: '',
    createdFor: '',
    createdBy: '',
    dataManagerType: '',
    createdDate: null,
    isDraft: isSchedular ? {key: 'N', value: 'Completed'} : '',
    clientCode: '',
  };
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const handleSubmit = (values) => {
    if (!isSchedular) {
      if (exportManager) {
        sessionStorage.setItem('EMSearchData', JSON.stringify(values));
      } else {
        sessionStorage.setItem('IMSearchData', JSON.stringify(values));
      }
    }

    setSearchData(values);
    setSubmit(true);
  };
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
    dispatch(getAllReportCreatedForData());
    setEditExisting && setEditExisting(false);
  }, []);

  useEffect(() => {
    if (!exportManager) {
      dispatch(fetchCreatedForDropDownData('importmanager'));
    } else {
      dispatch(fetchCreatedForDropDownData('exportmanager'));
    }
  }, [dispatch]);

  useEffect(() => {
    if (!exportManager) {
      dispatch(fetchCreatedByDropDownData('importmanager'));
    } else {
      dispatch(fetchCreatedByDropDownData('exportmanager'));
    }
  }, [dispatch]);

  const onClear = () => {
    const data = {
      dataManagerCode: '',
      dataManagerDescripton: '',
      createdFor: '',
      createdBy: '',
      dataManagerType: '',
      createdDate: null,
      isDraft: isSchedular ? {key: 'N', value: 'Completed'} : '',
      clientCode: '',
    };
    setSearchData(data);
    if (exportManager) {
      sessionStorage.removeItem('EMSearchData');
    } else {
      sessionStorage.removeItem('IMSearchData');
    }
  };

  const IMDataSessionStorage = exportManager ?
    JSON.parse(sessionStorage.getItem('EMSearchData')) :
    JSON.parse(sessionStorage.getItem('IMSearchData'));

  return (
    <div>
      <div className={
        exportManager ?
          'col-12 ' :
          isSchedular ? 'col-12' : ''} >
        <Formik
          onSubmit={handleSubmit}
          initialValues={
            IMDataSessionStorage && !isSchedular ? IMDataSessionStorage : initialValues
          }
          enableReinitialize
          validationSchema={validationSchema}
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              errors,
            } = props;

            return (
              <div>
                <Form autoComplete="off">
                  <div className="form-row  standard-field-textfields new-standard-textfields">
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group `}>
                      <TextField
                        margin="dense"
                        className={`${classes.labelName}`}
                        variant="outlined"
                        placeholder={`Enter ${exportManager ? 'Export' : 'Import'} Name`}
                        label={`${exportManager ? 'Export' : 'Import'} Name`}
                        name="dataManagerCode"
                        value={values?.dataManagerCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.dataManagerCode}
                      />
                    </div>
                    <div
                      className={
                        exportManager ?
                          'col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group' :
                          'col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group'
                      }
                    >
                      <TextField
                        margin="dense"
                        className={`${classes.labelName}`}
                        variant="outlined"
                        placeholder="Enter Description"
                        label="Description"
                        name="dataManagerDescripton"
                        value={values.dataManagerDescripton}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </div>
                    {!exportManager ? (
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="dataManagerType"
                          id="dataManagerType"
                          size="small"
                          value={values.dataManagerType}
                          options={importManagerType}
                          getOptionLabel={(option) => {
                            return option && option.value;
                          }}
                          onChange={(e, value) => {
                            setFieldValue('dataManagerType', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Type"
                                placeholder="Select Type"
                              />
                            </div>
                          )}
                        />
                      </div>
                    ) : null}

                    <div
                      className={
                        exportManager ?
                          'col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group' :
                          'col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group'
                      }
                    >
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="createdBy"
                        id="createdBy"
                        size="small"
                        value={values.createdBy}
                        options={createdByData}
                        getOptionLabel={(option) => {
                          return option && option?.userLoginName ? option?.userLoginName : '';
                        }}
                        renderOption={(option) => {
                          return createdByOptions(option);
                        }}
                        onChange={(e, value) => {
                          setFieldValue('createdBy', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={`${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Created By"
                              placeholder="Select Created By"
                            />
                          </div>
                        )}
                      />
                    </div>

                    <div
                      className={
                        exportManager ?
                          'col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group' :
                          'col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group'
                      }
                    >
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="createdFor"
                        id="createdFor"
                        size="small"
                        value={values.createdFor}
                        options={createdForData}
                        getOptionLabel={(option) => {
                          return option && option?.userLoginName ? option?.userLoginName : '';
                        }}
                        renderOption={(option) => {
                          return createForOptions(option);
                        }}
                        onChange={(e, value) => {
                          setFieldValue('createdFor', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={`${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Created For"
                              placeholder="Select Created For"
                            />
                          </div>
                        )}
                      />
                    </div>

                    <div
                      className={
                        exportManager ?
                          'col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group' :
                          'col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group'
                      }
                    >
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          className={`${classes.labelName}`}
                          format="MM/dd/yyyy"
                          placeholder="MM/DD/YYYY"
                          fullWidth
                          value={values.createdDate}
                          name="createdDate"
                          onBlur={handleBlur}
                          inputVariant="outlined"
                          helperText=""
                          label="Date Created"
                          onChange={(val) => {
                            setFieldValue('createdDate', val);
                          }}
                          error={Boolean(touched?.createdDate && errors?.createdDate)}
                          autoOk
                          margin="dense"
                        />
                      </MuiPickersUtilsProvider>
                      <FormHelperText variant="outlined">
                        {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                      </FormHelperText>
                    </div>

                    <div
                      className={
                        exportManager ?
                          'col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group' :
                          'col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group'
                      }
                    >
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="clientCode"
                        id="clientCode"
                        size="small"
                        value={values.clientCode}
                        options={clientCodeDropdownData || []}
                        getOptionLabel={(option) => {
                          return option && option?.clientName ? option?.clientName : '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('clientCode', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={`${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Client Code"
                              placeholder="Select Client Code"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div
                      className={
                        exportManager ?
                          'col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group' :
                          'col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group'
                      }
                    >
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        name="isDraft"
                        id="isDraft"
                        size="small"
                        options={StatusOptions}
                        required
                        value={values.isDraft}
                        disabled={isSchedular}
                        getOptionLabel={(option) => {
                          return option && option?.value;
                        }}
                        onChange={(e, value) => {
                          setFieldValue('isDraft', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={`${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Status"
                              placeholder="Select Status"
                            />
                          </div>
                        )}
                      />
                    </div>

                    <div
                      className={
                        exportManager ?
                          'col-md-4 col-lg-3 col-xl-3 form-group' :
                          'col-md-4 col-lg-12 col-xl-12 form-group new-standard-textfields'
                      }
                    >
                      <div
                        className={
                          exportManager ?
                            ' d-flex justify-content-center new-standard-textfields justify-content-xl-start' :
                            'd-flex justify-content-center new-standard-textfields'
                        }
                      >
                        <Button
                          variant="outlined"
                          className={`mr-1 reset-btn`}
                          onClick={() => {
                            handleReset();
                            setSubmit(true);
                            onClear();
                          }}
                        >
                          Reset
                        </Button>
                        <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                          Search
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <SearchDMTable
          setValue={setValue}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          exportManager={exportManager}
          isSchedular={isSchedular}
          setDMCode={setDMCode}
          setIsCodeSearch={setIsCodeSearch}
          setEditExisting={setEditExisting}
          DataManagerAccess={DataManagerAccess}
          setDmTableData={setDmTableData}
        />
      </div>
    </div>
  );
}

export default SearchDataManager;
